<template>
  <Drawer
    class="drawer_modal"
    width="700"
    v-model="showDrawer"
  >
    <customerDetail
      v-if="showDetailComponent"
      :id="itemId"
      :base_view_url="base_view_url"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @click_edit="editAction"
      @reload_table="$emit('reload-table')"
    ></customerDetail>

    <customerForm
      v-if="showFormComponent"
      v-model="itemId"
      :base_view_url="base_view_url"
      :action="itemAction"
      :item_type="item_type"
      @click_cancel="cancelAction"
      @show_detail="showDetail"
      @reload_table="$emit('reload-table')"
    ></customerForm>
  </Drawer>
</template>

<script>
  import { BaseItemData } from "../../base/base_item.js";

  import customerForm from "@/apps/customer/customerForm.vue";
  import customerDetail from "@/apps/customer/customerDetail.vue";

  let _app = BaseItemData();
  _app.components = {
    customerDetail,
    customerForm
  };
  _app.data = function() {
    return {
      titles: {
        detail: "Покупатель",
        edit: "Редактирование покупателя",
        create: "Создание покупателя"
      },
      itemAction: "detail",
      itemId: "",
      showDrawer: false
    };
  };
  export default _app;
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/customer/customerItem.vue